import React from 'react';
import { pick } from 'ramda';
import { useMyAccountSidebarSelector } from 'js/store/hooks';

import { HomePage } from './components/HomePage';
import { PortalPage } from './components/PortalPage';

import style from './Content.scss';

export const Content = () => {
    const { isOpened, portalPageURL } = useMyAccountSidebarSelector(pick(['isOpened', 'portalPageURL']));

    return (
        <>
            <div className={`${style.content} sidebar-content-wrapper`}>
                {isOpened && (
                    portalPageURL ? <PortalPage portalPageURL={portalPageURL} /> : <HomePage />
                )}
            </div>
        </>
    );
};
